'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {"z-index-100":"popup-module_z-index-100__ZHCKb","close":"popup-module_close__IrZjn","react-popper":"popup-module_react-popper__CID-m","popper__arrow":"popup-module_popper__arrow__eYbBj","popper__arrow--inner":"popup-module_popper__arrow--inner__QHTvR","popup-hover__target":"popup-module_popup-hover__target__uLJDf","popup-hover":"popup-module_popup-hover__I-h80","preload":"popup-module_preload__W3w-z","dropAnimation":"popup-module_dropAnimation__NkCrO","drop":"popup-module_drop__vfsvF"};

exports.default = styles;
//# sourceMappingURL=popup.module.scss.js.map
